export const getWindowVariable = (varName = ''): null | React.FunctionComponent | React.PureComponent => {
  const varData = typeof window === 'object' && varName ? window[varName] : '';
  let result = null;

  if (
    typeof varData === 'object' && varData && typeof varData.default !== 'undefined'
  ) {
    result = window[varName].default;
  }

  return result;
};

export type CSSTokens  =
| 'gray-01'
| 'gray-02'
| 'gray-03'
| 'gray-04'
| 'gray-05'
| 'gray-06'
| 'gray-07'
| 'gray-08'
| 'gray-09'
| 'gray-10'
| 'gray-11'
| 'gray-12'
| 'white'
| 'black'
| 'blue-01'
| 'blue-02'
| 'blue-03'
| 'blue-04'
| 'blue-05'
| 'blue-06'
| 'blue-07'
| 'blue-08'
| 'blue-09'
| 'blue-10'
| 'red-01'
| 'red-02'
| 'red-03'
| 'red-04'
| 'red-05'
| 'red-06'
| 'red-07'
| 'red-08'
| 'red-09'
| 'red-10'
| 'orange-01'
| 'orange-02'
| 'orange-03'
| 'orange-04'
| 'orange-05'
| 'orange-06'
| 'orange-07'
| 'orange-08'
| 'orange-09'
| 'orange-10'
| 'green-01'
| 'green-02'
| 'green-03'
| 'green-04'
| 'green-05'
| 'green-06'
| 'green-07'
| 'green-08'
| 'green-09'
| 'green-10';

export const token = <T>(key: CSSTokens | T, namespace = 'odc'): string => `var(--${namespace}-${key})`;

const toHyphen = (str: string) => str.replace(/([A-Z])/g, '-$1').toLowerCase();

export const genToken = (raw) => {
  const obj = {};
  Object.keys(raw).forEach((key) => {
    obj[`--${toHyphen(key)}`] = raw[key];
  });
  return obj;
};
